module.exports = __webpack_public_path__ + "static/img/sou-w-m@2x.cee46f6e.png";